import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

/** Edit mode: start date on or before today — only due date may change; rest of metadata and call flow are read-only. */
export function isCertificationStartInPastOrToday(start: Date | string | null | undefined): boolean {
  if (start == null) return false;
  return !dayjs(start).startOf("day").isAfter(dayjs().startOf("day"));
}

/** Both dates strictly before today — certification window ended; no edits allowed. */
export function areCertificationStartAndDueBothBeforeToday(
  start: Date | string | null | undefined,
  due: Date | string | null | undefined
): boolean {
  if (start == null || due == null) return false;
  const today = dayjs().startOf("day");
  return dayjs(start).startOf("day").isBefore(today) && dayjs(due).startOf("day").isBefore(today);
}

/**
 * Converts to API format: YYYY-MM-DD at midnight CST (UTC−6 = T06:00:00.000Z).
 * String values are parsed as UTC to extract the calendar date.
 */
export function toCertificationDatePayload(value: Date | string | null): string | null {
  if (value == null) return null;
  const d = typeof value === "string" ? dayjs.utc(value) : dayjs(value);
  return d.format("YYYY-MM-DD") + "T06:00:00.000Z";
}

/** Returns a user-facing error message if the due date is invalid; otherwise null. */
export function getCertificationDueDateValidationError(
  start: Date | string | null | undefined,
  due: Date | string | null | undefined
): string | null {
  if (due == null) return null;
  const dueDay = dayjs(due).startOf("day");
  const today = dayjs().startOf("day");
  if (start != null) {
    const startDay = dayjs(start).startOf("day");
    if (dueDay.isBefore(startDay)) {
      return "Due date must be on or after the start date.";
    }
  }
  if (dueDay.isBefore(today)) {
    return "Due date must be in the future.";
  }
  return null;
}
